export const bytebinUrl =
  process.env.REACT_APP_BYTEBIN_URL || 'https://bytebin.lucko.me/';

export const postUrl = bytebinUrl + 'post';
